import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import HubertHome from "@/pages/HubertHome";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import AdminChatConsole from "@/pages/AdminChatConsole";
import CancelReservation from "@/pages/CancelReservation";
import RatePage from "@/pages/RatePage";
import Rate2Page from "@/pages/Rate2Page";
import AdminReset from "@/pages/AdminReset";
import Gdpr from "@/pages/Gdpr";

function App() {
  return (
    <BrowserRouter>
      <Toaster theme="dark" position="top-center" richColors />
      <Routes>
        <Route path="/" element={<HubertHome />} />
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/chat" element={<AdminChatConsole />} />
        <Route path="/zrusit/:token" element={<CancelReservation />} />
        <Route path="/hodnoceni/:token" element={<RatePage />} />
        <Route path="/recenze/:token" element={<Rate2Page />} />
        <Route path="/admin/reset/:token" element={<AdminReset />} />
        <Route path="/ochrana-osobnich-udaju" element={<Gdpr />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
